/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { isArrayEmpty } from "cms/utils/empty-exists";
import { useImageLoader } from "cms/components/hero-carousel/use-image-map-loader";
import { HeroSlide } from "./hero-slide";
import { EmptyHeroSlide } from "./empty-hero-slide";

const Hero = (props) => {

    const { component } = props;
    const {
        getImageData,
        preloadImageArray,
        preloadImage,
    } = useImageLoader();
    const { slides = [] } = component || {};

    const [index, setIndex] = useState(0);
    const [images, setImages] = useState(null);

    const hasContent = !isArrayEmpty(slides);
    const total = slides?.length ?? 0;

    const buildSlidesData = async (_slides) => {
        if (!_slides) {
            return;
        }
        const datas = [];
        const first_data = await getImageData(_slides[0]?.image?.image);
        const first_image = await preloadImage(first_data);
        setImages([first_image]);
        try {
            for (const slide of _slides) {
                const image = slide?.image;
                const image_guid = image?.image;
                if (image_guid) {
                    const data = await getImageData(image_guid);
                    datas.push(data);
                }
            }
            const _images = await preloadImageArray(datas);
            setImages(_images);
        } catch (err) {
            console.error(err);
        }
        return images;
    };

    useEffect(() => {
        buildSlidesData(slides);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slides]);

    const moveIndex = (increment) => {
        let idx = index + increment;
        if (idx > slides.length - 1) {
            idx = 0;
        }
        if (idx < 0) {
            idx = slides.length - 1;
        }
        setIndex(idx);
    };

    if (!hasContent) {
        return <EmptyHeroSlide />;
    } else {
        return (
            <HeroSlide
                slides={slides}
                images={images}
                key={index}
                index={index}
                total={total}
                moveIndex={moveIndex}
            />
        );
    }
};

Hero.displayName = "Hero";
export { Hero };
